import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import ProductImage from "@/components/ProductImage";

export default function SellerProducts() {
    const { t } = useLang();
    const [products, setProducts] = useState([]);
    const load = () => api.get("/seller/products").then((r) => setProducts(r.data));
    useEffect(() => { load(); }, []);

    const del = async (id) => {
        if (!confirm("?")) return;
        await api.delete(`/products/${id}`);
        toast.success("✓");
        load();
    };

    return (
        <Layout>
            <div className="max-w-6xl mx-auto px-4 md:px-8 py-10">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-3xl md:text-4xl font-black text-espresso">{t("myProducts")}</h1>
                    <Link to="/seller/products/new"><Button className="rounded-full bg-terracotta text-white" data-testid="add-product-btn"><PlusCircle className="w-4 h-4 me-2" />{t("addProduct")}</Button></Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="seller-products-list">
                    {products.map((p) => (
                        <div key={p.product_id} className="bg-white border border-border rounded-2xl overflow-hidden">
                            <div className="aspect-video bg-surface">
                                <ProductImage
                                    src={p.images?.[0]}
                                    alt={p.title}
                                    imageClassName="w-full h-full object-cover"
                                    showLabel={false}
                                />
                            </div>
                            <div className="p-4">
                                <div className="font-bold text-espresso line-clamp-1">{p.title}</div>
                                <div className="mt-1 text-sm text-muted-foreground">{t("stock")}: {p.stock}</div>
                                <div className="mt-2 flex items-center justify-between">
                                    <div className="font-black text-terracotta">{p.price} {t("SAR")}</div>
                                    <div className="flex gap-1">
                                        <Link to={`/seller/products/${p.product_id}`}><Button size="icon" variant="ghost" className="rounded-full"><Pencil className="w-4 h-4" /></Button></Link>
                                        <Button size="icon" variant="ghost" className="rounded-full text-destructive" onClick={() => del(p.product_id)} data-testid={`del-${p.product_id}`}>
                                            <Trash2 className="w-4 h-4" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {products.length === 0 && (
                        <div className="col-span-full text-center py-16 text-muted-foreground">{t("noResults")}</div>
                    )}
                </div>
            </div>
        </Layout>
    );
}
